import { Controller } from "@hotwired/stimulus"

// The search box of an index page (`_search` partials). A search runs when it
// is sent, but emptying the box after one used to leave the filtered list
// standing until somebody sent the empty box or reloaded. Emptying it now sends
// the form by itself, which brings the whole list back. Searching while typing
// is deliberately not done: every keystroke would reload the page under the
// cursor.
export default class extends Controller {
  connect() {
    this.searched = this.element.value !== ""
  }

  reset() {
    if (this.searched && this.element.value === "") this.element.form.requestSubmit()
  }
}
